// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing_table th,
.listing_table td {
  text-align: left;
  cursor: pointer;
}
.listing_table th:last-child,
.listing_table td:last-child {
  text-align: center;
}
.listing_table .users_page_td {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/UsersListing/UsersListing.scss"],"names":[],"mappings":"AACI;;EAEI,gBAAA;EACA,eAAA;AAAR;AAGI;;EAEI,kBAAA;AADR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".listing_table {\r\n    th,\r\n    td {\r\n        text-align: left;\r\n        cursor: pointer;\r\n    }\r\n\r\n    th:last-child,\r\n    td:last-child {\r\n        text-align: center;\r\n    }\r\n    .users_page_td {\r\n        text-align: left;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
